import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  List,
  Collapse,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { UpOutlined, DownOutlined } from "@ant-design/icons";
import { useTheme } from "@mui/material/styles";
import { activeItem } from "store/reducers/menu";


const DynamicNavItemForWeed = ({ item, level }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const menu = useSelector((state) => state.menu);
  const { drawerOpen, openItem } = menu;
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };


  const itemHandler = (id) => {
    dispatch(activeItem({ openItem: [id] }));
  };

  const isSelected = openItem.includes(item.id);
  const iconSelectedColor = "primary.main";
  const textColor = "text.primary";

  useEffect(() => {
    const currentIndex = document.location.pathname
      .toString()
      .split("/")
      .findIndex((id) => id === item.id);
    if (currentIndex > -1) {
      dispatch(activeItem({ openItem: [item.id] }));
    }
    // eslint-disable-next-line
  }, []);

  const renderItem = (item, onClickHandler) => (
    <ListItemButton
      sx={{
        zIndex: 1201,
        pl: drawerOpen ? `${level * 28}px` : 1.5,
        py: !drawerOpen && level === 1 ? 1.25 : 1,
        ...(drawerOpen && {
          "&:hover": {
            bgcolor: "primary.lighter",
          },
          "&.Mui-selected": {
            bgcolor: "primary.lighter",
            borderRight: `2px solid ${theme.palette.primary.main}`,
            color: iconSelectedColor,
            "&:hover": {
              color: iconSelectedColor,
              bgcolor: "primary.lighter",
            },
          },
        }),
        ...(!drawerOpen && {
          "&:hover": {
            bgcolor: "transparent",
          },
          "&.Mui-selected": {
            "&:hover": {
              bgcolor: "transparent",
            },
            bgcolor: "transparent",
          },
        }),
      }}
      selected={isSelected}
      onClick={() => {
        handleClick();
        onClickHandler(item.id);
      }}
      key={item.id}
      component={Link}
      to={item.url}
    >
      {item.icon && (
        <ListItemIcon
          sx={{
            minWidth: 28,
            color: isSelected ? iconSelectedColor : textColor,
            ...(!drawerOpen && {
              borderRadius: 1.5,
              width: 36,
              height: 36,
              alignItems: "center",
              justifyContent: "center",
              "&:hover": {
                bgcolor: "secondary.lighter",
              },
            }),
            ...(!drawerOpen &&
              isSelected && {
                bgcolor: "primary.lighter",
                "&:hover": {
                  bgcolor: "primary.lighter",
                },
              }),
          }}
         
        >
          {item.icon}
        </ListItemIcon>
      )}
      <ListItemText primary={item.title} />
    
    </ListItemButton>
  );

  return (
    <>
      {renderItem(item, itemHandler)}
        {/* <List component="div" disablePadding>
          {item.children &&
            item.children.map((weed) => (
              <ListItemButton
                sx={{
                  zIndex: 1201,
                  pl: drawerOpen ? `${level * 28}px` : 1.5,
                  py: !drawerOpen && level === 1 ? 1.25 : 1,
                  ...(drawerOpen && {
                    "&:hover": {
                      bgcolor: "primary.lighter",
                    },
                    "&.Mui-selected": {
                      bgcolor: "primary.lighter",
                      borderRight: `2px solid ${theme.palette.primary.main}`,
                      color: iconSelectedColor,
                      "&:hover": {
                        color: iconSelectedColor,
                        bgcolor: "primary.lighter",
                      },
                    },
                  }),
                  ...(!drawerOpen && {
                    "&:hover": {
                      bgcolor: "transparent",
                    },
                    "&.Mui-selected": {
                      "&:hover": {
                        bgcolor: "transparent",
                      },
                      bgcolor: "transparent",
                    },
                  }),
                }}
                key={weed.id}
                {...listItemProps}
                onClick={() => {
                  handleClick();
                }}
                component={Link}
                to={weed.url}
              >
                <ListItemText
                  primary={weed.name}
                  sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: "210px",
                  }}
                />
              </ListItemButton>
            ))}
        </List> */}
    </>
  );
};

DynamicNavItemForWeed.propTypes = {
  item: PropTypes.object,
  level: PropTypes.number,
};

export default DynamicNavItemForWeed;
